import { Component, inject, input } from '@angular/core';
import { AvatarComponent } from '../avatar.component';
import { AvatarService } from 'app/store/avatar.service';

@Component({
  selector: 'app-avatar-container',
  standalone: true,
  imports: [AvatarComponent],
  templateUrl: './avatar-container.component.html',
  styleUrl: './avatar-container.component.scss',
})
export class AvatarContainerComponent {
  name = input.required<string>();
  avatar = inject(AvatarService);
  avatarUrl = this.avatar.avatarUrl;
}
